<template>
  <main class="container solution-air">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Air Purifier</button>
      <h1>
        CESCO Safeguards <br class="mo_show" />Air Quality
        <br />
        of Your Home
      </h1>
      <p>
        Detects invisible harmful substances such as radon radiation, (ultra)fine particles, CO₂, and volatile organic compounds. In addition, it
        enhances the filter’s ability to inhibit the growth of viruses, bacteria, and mold by 3UP for stronger management.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img :src="require(`@/assets/images/solution/air/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="CESCO [Solution] Air Purifier" />

    <section class="section solution-air-1">
      <div class="contents-center">
        <h3 class="title-section">Does an air purifier need to do all this?</h3>
        <div class="cards">
          <div class="card">
            <div>
              <h4>
                At CESCO,
                <br />
                we constantly asked ourselves these questions.
              </h4>
              <p>
                Are six expensive sensors necessary for an air purifier? Should we continue operating an air quality integrated situation room that
                costs billions in installation and maintenance? Is the readiness of over 3,000 professionals for emergency services essential?
              </p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/card_image_01.png" alt="CESCO [Solution] Air Purifier" />
            </div>
          </div>
          <div class="card">
            <div>
              <h4>
                However,
                <br />
                we could not neglect any aspects.
              </h4>
              <p>
                We must combat radon radiation from the ground, CO2 and VOCs in enclosed spaces, as well as fine and ultrafine particles. We must
                fight not with outdated methods but with our innovative approach. If it were merely an adequate air purifier that filtered out fine
                dust, CESCO would not have initiated the project.
              </p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/card_image_02.png" alt="CESCO [Solution] Air Purifier" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-air-2">
      <div class="contents-center">
        <h3 class="title-section center">CESCO Air's Promises</h3>
        <p class="description-section center">
          CESCO Air offers six unique features that provide precise air quality measurements and <br class="pc_show" />
          scientifically tailored solutions to manage indoor air.
        </p>

        <div class="promise-card">
          <span class="promise-number"> Promise 01 </span>
          <div class="header">
            <h3 class="title">Detects Harmful Air in Real Time</h3>
            <p class="description">
              Fine dust is not the only hazard. CESCO Air purifiers come equipped with six ultra-precision sensors capable of detecting substances far
              more dangerous than fine dust.
            </p>
          </div>

          <div class="layout-f">
            <div>
              <img src="@/assets/images/solution/air/layout_f_01.png" alt="CESCO [Solution] Air Purifier" />
              <h4>Radon Radiation Sensor</h4>
              <p>Radon enters indoors through cracks</p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/layout_f_02.png" alt="CESCO [Solution] Air Purifier" />
              <h4>(Ultra)fine Dust Sensor</h4>
              <p>Enters indoors through doors and windows</p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/layout_f_03.png" alt="CESCO [Solution] Air Purifier" />
              <h4>VOCs (Odors) Sensor</h4>
              <p>VOCs released even in everyday life</p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/layout_f_04.png" alt="CESCO [Solution] Air Purifier" />
              <h4>CO2 sensor</h4>
              <p>CO2 released even in everyday life</p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/layout_f_05.png" alt="CESCO [Solution] Air Purifier" />
              <h4>Temperature Sensor</h4>
              <p>Temperature varies with the seasons and weather</p>
            </div>
            <div>
              <img src="@/assets/images/solution/air/layout_f_06.png" alt="CESCO [Solution] Air Purifier" />
              <h4>Humidity Sensor</h4>
              <p>Humidity varies with indoor conditions during seasonal changes</p>
            </div>
          </div>
        </div>

        <div class="promise-card">
          <span class="promise-number"> Promise 02 </span>
          <div class="header">
            <h3 class="title">Ventilation Timing Alert</h3>
            <p class="description">
              Displays indoor and outdoor air quality in colors,
              <br />
              informing you of the optimal times for ventilation, 24 hours a day.
            </p>
          </div>
          <img src="@/assets/images/solution/air/promise_card_01.png" alt="CESCO [Solution] Air Purifier" />
        </div>

        <div class="promise-card">
          <span class="promise-number"> Promise 03 </span>
          <div class="header">
            <h3 class="title">Multi-Filter System</h3>
            <p class="description">
              Our rigorous multi-filter system not only removes 99.99% of ultrafine particles but also eliminates harmful gases.
            </p>
          </div>
          <img :src="require(`@/assets/images/solution/air/promise_card_03${mobileCheck ? '_mo' : ''}.svg`)" alt="CESCO [Solution] Air Purifier" />
        </div>
      </div>
    </section>

    <section class="navi-swiper solution-air-3">
      <div>
        <h3>Product Introduction</h3>
        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <p>
        Smart choice, Fit your style. Choose Smart-Fit, a smart choice that suits your style.<br />
        Each product has a different release schedule. Please send Email for more information.
      </p>

      <swiper ref="swiperRef" :slides-per-view="'auto'" @slideChange="onSlideChange">
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT RadonPlus</h3>
              <span class="up-number"> 3 UP </span>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_01.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">
              Manages everything from ultrafine particles to radon, CO2 detection, and inhibits the growth of viruses, bacteria, and mold.
            </div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_02.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association for Fine Dust Sensor
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT</h3>
              <span class="up-number"> 3 UP </span>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_03.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">
              Handles everything from ultrafine particles to CO2 detection, and inhibits the growth of viruses, bacteria, and mold.
            </div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_04.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT RadonPlus SE</h3>
              <span class="up-number"> 3 UP </span>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_05.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">
              Handles everything from ultrafine particles to CO2 detection, and inhibits the growth of viruses, bacteria, and mold.
            </div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_04.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT RadonPlus SE</h3>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_06.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">Provides continuous management of invisible harmful substances from ultrafine particles to radon and CO2.</div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_02.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association for Fine Dust Sensor
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT SE</h3>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_07.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">Manages invisible indoor air quality scientifically.</div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_04.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>IoT Radon RoomCare</h3>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_08.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">Initiates safe air quality management from ultrafine particles to radon radiation.</div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_04.png" class="icon" alt="CESCO [Solution] Air Purifier" />
            <p class="certified">
              Certified by the Korea Air Cleaning
              <br />
              Association
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>Smart-Fit 30</h3>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_09.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">Smartly manages air quality with options tailored to your usage environment.</div>
          </div>

          <div class="footer">
            <img src="@/assets/images/solution/air/air_swiper_10.png" class="gdk-icon" alt="CESCO [Solution] Air Purifier" />
          </div>
        </swiper-slide>
        <swiper-slide class="card-type-l">
          <div class="header">
            <div class="title">
              <h3>Smart-Fit 10</h3>
            </div>
            <img class="thumnail" src="@/assets/images/solution/air/air_swiper_11.png" alt="CESCO [Solution] Air Purifier" />
            <div class="content">Smartly manages air quality with options tailored to your usage environment.</div>
          </div>
        </swiper-slide>
      </swiper>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        Presto! Let's go! CESCO!CESCO is
        <br class="pc_show" />
        dedicated to protecting your home’s
        <br class="pc_show" />
        air quality.
      </h2>
      <p>CESCO Air delivers customized solutions that uniquely manage indoor air.</p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
// import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'
import { useScroll, useSlide } from '@/hooks'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { swiperRef, slidePrev, slideNext } = useSlide()

const mobileCheck = inject('mobileCheck')

const prevDisabled = ref(true)
const nextDisabled = ref(false)

const onSlideChange = e => {
  const isBeginning = e.isBeginning
  const swiperIndex = e.realIndex

  if (isBeginning) prevDisabled.value = true
  else prevDisabled.value = false

  if (swiperIndex >= 5) nextDisabled.value = true
  else nextDisabled.value = false
}

useMeta({
  title: 'CESCO - Air Purifier',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'CESCO Safeguards Air Quality of Your Home'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/air.scss';
</style>
